import React, { useState } from 'react';
import { Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import './App.css';
import Home from './components/Home';
import SubcontractorRegistration from './components/SubcontractorRegistration';
import CompanyRegistration from './components/CompanyRegistration';
import Contact from './components/Contact';
import Admin from './components/Admin';
import Estimator from './components/Estimator';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';
import logo from './assets/logo.jpg';

function App() {
  const [navExpanded, setNavExpanded] = useState(false);
  const location = useLocation();

  const handleNavClick = () => {
    setNavExpanded(false);
  };

  return (
    <div className="App min-vh-100 d-flex flex-column">
      <ScrollToTop />
      <Navbar
        variant="dark"
        expand="lg"
        sticky="top"
        className="shadow-sm main-navbar"
        expanded={navExpanded}
        onToggle={setNavExpanded}
      >
        <Container>
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center" onClick={handleNavClick}>
            <img
              src={logo}
              alt="United Arborist Logo"
              width="40"
              height="40"
              className="me-2 rounded-circle"
              style={{ objectFit: 'cover' }}
            />
            <span className="fw-bold">United Arborist</span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="main-navbar" />
          <Navbar.Collapse id="main-navbar">
            <Nav className="ms-auto">
              <Nav.Link as={Link} to="/" active={location.pathname === '/'} onClick={handleNavClick}>
                Home
              </Nav.Link>
              <Nav.Link as={Link} to="/contact" active={location.pathname === '/contact'} onClick={handleNavClick}>
                Contact
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/subcontractor-registration"
                active={location.pathname === '/subcontractor-registration'}
                onClick={handleNavClick}
              >
                Subcontractor Registration
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/company-registration"
                active={location.pathname === '/company-registration'}
                onClick={handleNavClick}
              >
                Company Registration
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/estimator"
                active={location.pathname === '/estimator'}
                onClick={handleNavClick}
              >
                Job Estimator
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <main className="flex-grow-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/subcontractor-registration" element={<SubcontractorRegistration />} />
          <Route path="/company-registration" element={<CompanyRegistration />} />
          <Route path="/estimator" element={<Estimator />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      <footer className="site-footer mt-auto">
        <Container>
          <p className="text-center mb-0">
            &copy; {new Date().getFullYear()} United Arborist
            <span className="mx-2">|</span>
            <Link to="/admin">Admin</Link>
          </p>
        </Container>
      </footer>

      <CookieConsent />
    </div>
  );
}

export default App;
